/**
 * Rounds a given number to the specified precision and converts it to a string without trailing zeros
 *
 * @param value - The number to be rounded.
 * @param precision - The number of significant digits to round to.
 * @returns The rounded number as a string.
 */
export const roundToPrecision = (value: number, precision: number) => parseFloat(value.toFixed(precision)).toString();
